import { Container, Button, Col, Row } from "react-bootstrap";
import { AlmataMainLogo } from "../../assets/image";
import "../../styles/NotFound.css";

export default function NotFound() {
  return (
    <div className="not-found-container">
      <Container className="d-flex flex-column justify-content-center align-items-center vh-100 text-center">
        <Row className="not_found_card">
          <Col md={12}>
            <div className="not_found_header">
              <img
                src={AlmataMainLogo}
                alt="Cyber Risk Report Logo"
                className="login-logo"
              />
              <h2 className="error-title">Oops! Page Not Found</h2>
              <p className="error-message">
                The page you're looking for doesn't exist.
              </p>
            </div>
            <div className="error-actions">
            
              <Button
                className="back-btn"
                onClick={() => window.history.back()}
              >
                <i className="bi bi-arrow-left me-2"></i>
                Go Back
              </Button>
                <Button href="/"  className="home_back_btn ms-3">
                <i className="bi bi-house-fill me-2"></i>
                Back to Home
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
